<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :form-fields="formFields"
                      :permission="permission"
                      :url="url"
                      :operate="[]"
                      :searchs="searchs"
        />
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "UserDailyInvestmentIncome",
        components: { CommonTable },
        data() {
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'phone',
                    placeholder: '用户',
                    type: 'input'
                }, {
                    name: 'status',
                    placeholder: '请选择状态',
                    type: 'select',
                    selectValue:[{
                        key: 0,
                        value: '未领取'
                    },{
                        key: 1,
                        value: '已领取'
                    }]
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                permission: {
                    /*add: 'userDailyInvestmentIncome:add',
                    update: 'userDailyInvestmentIncome:update',
                    delete: 'userDailyInvestmentIncome:delete',
                    deleteBatch: 'userDailyInvestmentIncome:deleteBatch'*/
                },
                url: {
                    get: '/userDailyInvestmentIncome/listByCondition',
                    /*add: '/userDailyInvestmentIncome/add',
                    update: '/userDailyInvestmentIncome/update',
                    delete: '/userDailyInvestmentIncome/delete',
                    delete_batch: '/userDailyInvestmentIncome/deleteBatch',*/
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'userDailyInvestmentId',
                    label: '数据ID',
                    show: true,
                    width: '',
                }, {
                    field: 'dailyInvestmentId',
                    label: '产品ID',
                    show: true,
                    width: '',
                }, {
                    field: 'name',
                    label: '产品名称',
                    show: true,
                    width: '',
                }/*, {
                field: 'userId',
                label: '用户昵称',
                selectUrl: '/userInfo/getAll',
                show: {
                    type: 'select'
                },
                selectData: [],
                width: '',
            }*/, {
                    field: 'phone',
                    label: '用户',
                    show: true,
                    width: '',
                }, {
                    field: 'earnings',
                    label: '收益(USDT)',
                    show: true,
                    width: '',
                }, {
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '已领取',
                            type: 'success'
                        }, {
                            key: 0,
                            value: '未领取',
                            type: 'warning'
                        }]
                    },
                    width: '',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    model: []
                }
            }
        }
    }
</script>

<style scoped>

</style>
